export function applyMerge<T>(
    merged: Partial<T>,
    intended: Partial<T>,
    immutable: string[],
    system: string[]
) {
    for (const key of Object.keys(intended) as Array<keyof T>) {
        if (immutable.includes(key as string) || system.includes(key as string)) {
            continue;
        }

        const value = intended[key];
        if (value !== undefined) {
            merged[key] = value;
        }
    }
}
